import {closeModal} from 'snippets/_containers/modal/modal';
import {cartSubtotalUpdate, createFormObject, fetchCartSectionAndUpdate, getCart} from 'snippets/cart-js/cart-helpers';

const translations = window.translations,
    localeUrl = window.localeUrl;

const openEvent = new Event('open');

document.addEventListener('DOMContentLoaded', () => {

    Shopify.AjaxifyCart = () => {

        const _config = {

            // What you might want to change
            addToCartBtnLabel             : translations.addToCart,
            addedToCartBtnLabel           : translations.addingToCart,
            addingToCartBtnLabel          : translations.addingToCart,
            soldOutBtnLabel               : translations.soldOut,
            howLongTillBtnReturnsToNormal : 800, // in milliseconds.
            cartCountSelector             : '.cart__item-count',
            cartCountScreenReader         : '.cart__item--count-sr',
            cartTotalSelector             : '#cart-price',

            // What you will never need to change
            addToCartBtnSelector          : '.btn--add-to-cart--quick',
            addToCartFormSelector         : 'form[action="/cart/add"]',
            shopifyAjaxAddURL             : localeUrl+'/cart/add.js',
            shopifyAjaxCartURL            : localeUrl+'/cart.js',
            productPriceWrapper           : '[data-price-wrapper]',
            productComparePrice           : '[data-compare-price]',
            productQuantityInput          : 'input[name="quantity"]',
        };

        const _setText = function(button, label) {
            if (button?.children.length) {
                button.children.forEach(function(child) {
                    if (child.textContent.trim() !== '') {
                        child.textContent = label;
                    }
                });
            } else if(button) {
                button.textContent = label;
            }
        };

        var _init = function() {
            // Empty the cart if there are only free sample products in cart
            getCart()
                .then(cart => {
                    if(!cart) return;
                    const cart_items_subtotal_price = cart.items_subtotal_price;
                    const cart_item_count = cart.item_count;
                    if (cart_items_subtotal_price == 0 && cart_item_count > 0) {
                        fetch(localeUrl+'/cart/clear.js', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify({})
                        })
                            .then(() => {
                                location.reload(true);
                            })
                            .catch(error => {
                                console.error(error);
                            });
                    }
                })
                .catch(error => {
                    console.error(error);
                });

            // Loop through all ATC forms, in case quick ATC is present in product cards.
            const addToCartForms = document.querySelectorAll(_config.addToCartFormSelector);

            addToCartForms.forEach((addToCartForm) => {

                if ( addToCartForm.dataset.isAjax == 'true' ) {
                    addToCartForm.addEventListener('submit', function(e){
                        e.preventDefault();

                        const cartMessageError = addToCartForm.querySelector('.cart__message--error');

                        // Remove error message
                        if(cartMessageError != null) {
                            cartMessageError.textContent = '';
                        }

                        const addToCartBtn = addToCartForm.querySelector(_config.addToCartBtnSelector),
                            addToCartText     = addToCartForm.querySelector('[data-add-to-cart-text]'),
                            addToCartBtnCard  = addToCartForm.querySelector('.quick-cart-add__loader');

                        // Get current label to reapply after cart submitted
                        _config.addToCartBtnLabel = addToCartText.textContent;

                        if (document.body.classList.contains('template-product') && addToCartForm.classList.contains('quick-cart-add__product-hero')) {
                            _setText(addToCartText, _config.addingToCartBtnLabel);
                        } else if (addToCartForm.getAttribute('data-add-cart-type') == 'modal') { // Cart Modal case
                            // Change Button Text to indicate that product is adding to cart
                            _setText(addToCartText, _config.addingToCartBtnLabel);
                            addToCartBtn.classList.add('disabled');
                            addToCartBtn.disabled = true;
                            addToCartBtn.classList.add('button--active');
                        } else {
                            _setText(addToCartBtnCard, _config.addingToCartBtnLabel);
                        }

                        const formData = new FormData(addToCartForm);
                        const formObject = createFormObject(formData);

                        let sellingPlan = null;
                        const inputName = `manual_or_subscribe-${formObject.id}`;
                        if(formObject?.[inputName] === 'subscribe') {
                            const subscriptionPlanKey = `subscriptionPlan-${formObject.id}`;
                            sellingPlan = parseInt(formObject[subscriptionPlanKey]);
                        } else if (formObject?.[`options[${inputName}]`] === 'subscribe') {
                            const subscriptionPlanKey = `subscriptionPlan-${formObject.id}`;
                            sellingPlan = parseInt(formObject[`options[${subscriptionPlanKey}]`]);
                        }

                        let formPayload;

                        if (addToCartForm.dataset.addCartType === 'multi') {
                            formPayload = {
                                'items': []
                            };
                            formObject.id.forEach((id, index) => {
                                formPayload.items.push({ id: id, quantity: formObject.quantity[index], selling_plan: formObject.selling_plan ?? sellingPlan });
                            });
                        } else {
                            formPayload = {
                                'items': [{...formObject, 'selling_plan': formObject.selling_plan ?? sellingPlan}]
                            };
                        }

                        fetch(_config.shopifyAjaxAddURL, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify(formPayload)
                        })
                            .then((response) => {
                                if(response.status!==200) {
                                    throw response;
                                } else {
                                    return response.json();
                                }
                            })
                            .then(() => {
                                addToCartBtnCard?.classList.add('button--active');

                                if (addToCartForm.getAttribute('data-add-cart-type') == 'modal') {
                                    Shopify.freeShippingProgress().init();
                                }

                                if (document.body.classList.contains('template-product') && addToCartForm.classList.contains('quick-cart-add__product-hero')) {
                                    _setText(addToCartText, _config.addedToCartBtnLabel);
                                    addToCartBtn.classList.add('disabled');
                                    addToCartBtn.disabled = true;
                                    addToCartBtn.classList.add('button--active');
                                } else {
                                    _setText(addToCartBtnCard, _config.addedToCartBtnLabel);
                                }

                                window.setTimeout(function(){
                                    addToCartBtnCard?.classList.remove('button--active');
                                    addToCartBtn.classList.remove('button--active');
                                    addToCartBtn.classList.remove('disabled');
                                    addToCartBtn.disabled = false;

                                    if (document.body.classList.contains('template-product') && addToCartForm.classList.contains('quick-cart-add__product-hero')) {
                                        _setText(addToCartText, _config.addToCartBtnLabel);
                                    } else if (addToCartForm.getAttribute('data-add-cart-type') == 'modal') { // Cart Modal case
                                        _setText(addToCartText, _config.addToCartBtnLabel);
                                    }
                                }, _config.howLongTillBtnReturnsToNormal);

                                // Update cart count
                                fetch(_config.shopifyAjaxCartURL, {
                                    cache: 'no-cache',
                                    headers: {
                                        'Content-Type': 'application/json'
                                    }
                                })
                                    .then((response) => response.json())
                                    .then((cart) => {
                                        const cartCountSelector = document.querySelectorAll(_config.cartCountSelector);

                                        if (cartCountSelector && cartCountSelector.length > 0) {
                                            cartCountSelector.forEach((cartCount) => {
                                                cartCount.textContent = cart.item_count;
                                            });
                                        }

                                        if(document.querySelector('.template-cart') !== null) {
                                            fetchCartSectionAndUpdate();
                                        } else {
                                            cartSubtotalUpdate(cart);
                                        }
                                    });

                                triggerOpenSidebarCart();
                            })
                            .catch(async (error) => {
                                try {
                                    const errorObject = await error.json();
                                    if (errorObject?.description) {
                                        const errorDescription = errorObject.description;

                                        if (errorDescription.slice(0,4) === 'All ') {
                                            addToCartForm.querySelector('.cart__message--error').textContent = "You can't add more of this product to the cart.";
                                            _setText(addToCartText, _config.soldOutBtnLabel);
                                            addToCartBtn.disabled = true;
                                            return;
                                        } else {
                                            addToCartForm.querySelector('.cart__message--error').textContent = errorDescription;
                                            addToCartBtn.disabled = false;
                                            addToCartBtn.classList.remove('disabled');
                                            _setText(addToCartText, _config.addToCartBtnLabel);
                                            return;
                                        }
                                    }
                                } catch {
                                    console.error(error);
                                }

                            });
                        return false;
                    });
                }
            });
        };
        return {
            init: (params) => {
                // Configuration
                params = params || {};
                // Merging with defaults.
                Object.assign(_config, params);
                // Action
                _init();
            },
            getConfig: () => {
                return _config;
            }
        };
    };
    Shopify.AjaxifyCart().init();
});

export function triggerOpenSidebarCart() {
    const sidebarCart = document.querySelector('.sidebar-cart');
    if(sidebarCart !== null) {
        // If the add to cart modal is open, close it.
        closeModal();
        sidebarCart.dispatchEvent(openEvent);
    }
}
